import React, { useEffect, useReducer, useRef  } from "react";

// Interface for component state
interface InputNumberState {
	value: number;
}

// Interface for component props
interface InputNumberProps {
	value?: number;
	min: number;
	max: number;
	dispatch: (action: [string, number]) => void;
}

const InputNumberReducer = function( state: InputNumberState, [ type, data ]: [string, number] ): InputNumberState {

	if( type === "value" ){
		return {
			...state,
			value: data
		};
	};

	return state;
};

export const InputNumber = ( props: InputNumberProps ) => {

	const [ state, dispatch ] = useReducer( InputNumberReducer, {
		value: props.value || 0
	});
	useEffect(() => {
		dispatch([ "value", props.value! ]);
	}, [ props.value ]);

	return(
		<div className={ "inp-number" }>
			<input className={ "inp-number-val" }
				type={ "number" }
				min={ props.min }
				max={ props.max }
				value={ state.value }
				onBlur={( e: React.FocusEvent<HTMLInputElement> ) => {

					let val = parseInt(e.target.value);

					if( val < props.min )
						val = props.min;
					if( val > props.max )
						val = props.max;

					props.dispatch([ "range", val ]);
				}}
				onChange={( e: React.ChangeEvent<HTMLInputElement> ) => props.dispatch([ "range", parseInt(e.target.value) ]) }
			/>
		</div>
	);
};